import { render, staticRenderFns } from "./MenuSideBar.vue?vue&type=template&id=44836672&"
import script from "./MenuSideBar.vue?vue&type=script&lang=js&"
export * from "./MenuSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports